import React from 'react';
import {
	Row,
	Col,
	Input,
	Label
} from 'reactstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SalesArea from 'components/Products/SalesArea';
import StockForecast from 'components/Products/StockForecast';
import PipelineDropdown from 'components/Products/PipelineDropdown';
import PipelineFilter from 'components/Products/PipelineFilter';
import CogsDurationDropdown from './CogsDurationDropdown';

class ProductsNav extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			sartDate: null,
			endDate: null,
			forecastCurrent: ''
		}
	}

	updateForecast = (forecast) => {
		this.setState({
			startDate: null,
			forecastCurrent: forecast});
		this.props.updateAllProducts(null, forecast);
	}

	updateAllProducts = (date) => {
		this.setState({startDate: date});
		this.props.updateAllProducts(date, this.state.forecastCurrent);
	}

	updateCogs = () => {
		this.props.updateAllCogs(this.state.startDate, this.state.endDate);
	}

	updateDate = (key, date) => {
		var obj = {};
		obj[key] = date;
		this.setState(obj, () => {
			this.props.updateDate(key, date);
		});
	}

	updateGrowthPercentage = (event) => {
		this.props.updateGrowthPercentage(event.target.value);
	}

	render() {
		const {forecastCurrent} = this.state;
		return (
			<>
				<Row>
					<Col xs={2}>
						<h5>Sales Area:</h5>
					</Col>
					<Col xs={4}>
						<SalesArea salesArea={this.props.salesArea}
							updateProductList={this.props.updateProductList}/>
					</Col>
					{
						this.props.forecastOptions && <>
							<Col xs={2}>
						<h5>Stock Forecast:</h5>
					</Col>
					<Col xs={4}>
						<StockForecast updateForecast={this.updateForecast}
							forecastOptions={this.props.forecastOptions}/>
					</Col>
						</>
					}
				</Row>
				<Row>
					{
						this.props.pipelines && <>
							<Col xs={2}>
						<h5>Ignore Pipeline:</h5>
					</Col>
					<Col xs={4}>
						<PipelineDropdown pipelines={this.props.pipelines}
							updateFilters={this.props.updateFilters}/>
					</Col>
					<Col>
					{this.props.pipelineFilters && this.props.pipelineFilters.map(p => {
						return (
							<PipelineFilter key={p.ID} filter={p}
								removeFilter={this.props.removeFilter}/>
						)
					})}
					</Col>
						</>
					}
				</Row>
				{this.props?.forecastOptions && forecastCurrent === this.props.forecastOptions[1] &&
					<Row>
						<Col xs={2}>
							<h5>Won deals starting:</h5>
						</Col>
						<Col xs={6}>
							<DatePicker
								selected={this.state.startDate}
								onChange={this.updateAllProducts}
								dateFormat={'yyyy-MM-dd'}
								maxDate={new Date()}/>
						</Col>
					</Row>
				}
				{this.props.forecastOptions && forecastCurrent === this.props.forecastOptions[2] &&
					<Row>
						<Col xs={2}>
							<h5>Forecast until:</h5>
						</Col>
						<Col xs={6}>
							<DatePicker
								selected={this.state.startDate ? this.state.startDate :
													this.props.forecastEnd}
								onChange={this.updateAllProducts}
								dateFormat={'yyyy-MM-dd'}
								minDate={new Date()}/>
						</Col>
						<Col xs={2}>
							<Label for={`growth-percentage`}>Growth %</Label>
							<Input name={`growth-percentage`}
								onChange={this.updateGrowthPercentage}
								value={this.props.growthPercentage} />
						</Col>
					</Row>
				}
				{
					this.props.cogsSelect && <>
					<Row>
						<Col xs={2}>
							<h5>Between Dates (inclusive)</h5>
						</Col>
						<Col xs={2}>
							<DatePicker selected={this.state.startDate || new Date()}
							onChange={(date) => this.updateDate('startDate', date)}
							dateFormat={'yyyy-MM-dd'}/>
						</Col>
						<Col xs={2}>
							<DatePicker selected={this.state.endDate || new Date()}
							onChange={(date) => this.updateDate('endDate', date)}
							dateFormat={'yyyy-MM-dd'}/>
						</Col>
					</Row>
					<Row>
						<Col xs={4}>
						<CogsDurationDropdown
							updateFilters={this.props.cogsDurationChange}/>
					</Col>
					</Row>
					</>
				}
			</>
		);
	}
}

export default ProductsNav;
